import { CHANNEL_ID_WEB } from '@/data/constants/order';

/**
 * Resolves the sales channel id (BUSCHN_ID) from an ordered list of
 * [matches, channelId] checks. The first match wins, mirroring the
 * precedence order declared in the backend's wc-devices.xml (e.g. the
 * app device group is declared before the generic mobile device groups).
 * Falls back to CHANNEL_ID_WEB when nothing matches.
 */
export const resolveChannelId = (checks: [boolean, string][]): string =>
	checks.find(([matches]) => matches)?.[1] ?? CHANNEL_ID_WEB;
